//展示我的打点区域
import './index.scss'

import { Button, Card, Flex, Image, Modal } from "antd";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom"
import { getSelectedPhotoAPI, getShowLocationAPI, setShowLocationVisibleAPI, } from '@/apis/showLocation';

import { useTranslation } from "react-i18next";
import { SERVER_CONF } from '@/config/server'
const BASE_SERVER_URL_LOCAL = SERVER_CONF.BASE_URL

const MyShowLocationDetail = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const showLocationId = searchParams.get("id")
    const [showLocation, setShowLocation] = useState([])
    const [photo, setPhoto] = useState("")
    const [isModalOpen, setIsModalOpen] = useState(false);//控制场地分享码
    const [isModalOpen1, setIsModalOpen1] = useState(false);//控制是否隐藏

    //i18n国际化
    const { t } = useTranslation();

    //场地分享码弹窗
    const showModal = () => {
        //console.log("showLocation:", showLocation);
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    //是否隐藏地点弹窗
    const showModal1 = () => {
        //console.log("showLocation:", showLocation);
        setIsModalOpen1(true);
    };
    //隐藏地点
    const handleOk1 = async () => {
        let res = await setShowLocationVisibleAPI(showLocation.id, 1)
        setIsModalOpen1(false);
    };
    //不隐藏地点
    const handleCancel1 = async () => {
        let res = await setShowLocationVisibleAPI(showLocation.id, 0)
        setIsModalOpen1(false);
    };

    //显示当前点击的图片类型
    const handleClick = async (showLocationId, selectedId) => {
        let newPhoto = await getSelectedPhotoByAPI(showLocationId, selectedId)
        setPhoto(newPhoto)
    }

    //通过接口获取显示的图片
    async function getSelectedPhotoByAPI(showLocationId, selectedId) {
        const res = await getSelectedPhotoAPI(showLocationId, selectedId)
        return res.data
    }

    useEffect(() => {
        //通过接口获取打点地点数据
        async function getShowLocationByIdAPI() {
            let res = await getShowLocationAPI(showLocationId)
            const showLocation = res.data
            setShowLocation(showLocation)
            const currPhoto = showLocation.photo
            setPhoto(currPhoto)
        }
        getShowLocationByIdAPI()
    }, [])

    return (
        <Flex justify={"center"}>
            <Card
                size="small"
                title={showLocation.placeName}
                hoverable
                cover={<Image className='card-img' src={BASE_SERVER_URL_LOCAL + photo} alt='' />}
                className='card'
                style={{
                    width: 300,
                }}
                actions={[
                    <button type='button' style={{border:'none',background:'none',padding:0,cursor:'pointer',color:'#1677ff'}} onClick={() => handleClick(showLocation.id, 0)}>{t('ShowLocation.CardAction.TakeOffArea')}</button>,
                    <button type='button' style={{border:'none',background:'none',padding:0,cursor:'pointer',color:'#1677ff'}} onClick={() => handleClick(showLocation.id, 1)}>{t('ShowLocation.CardAction.WatchingArea')}</button>,
                    <button type='button' style={{border:'none',background:'none',padding:0,cursor:'pointer',color:'#1677ff'}} onClick={() => handleClick(showLocation.id, 2)}>{t('ShowLocation.CardAction.Rendering')}</button>,
                ]}
            />
            <Flex style={{ width: 500, marginTop: 50, marginLeft: 50 }} vertical>
                <p>{t('ShowLocation.FormList.PlaceName')}:{showLocation.placeName}</p>
                <p>{t('ShowLocation.FormList.Adress')}:{showLocation.address}</p>
                <p>{t('ShowLocation.FormList.WindLevel')}:{showLocation.windLevel}</p>
                <p>{t('ShowLocation.FormList.GeomagneticDetection')}:{showLocation.geomagneticDetections}</p>
                <p>{t('ShowLocation.FormList.FlyableAmount')}:{showLocation.uavMin}-{showLocation.uavMax}</p>
                <p>{t('ShowLocation.FormList.Info')}:{showLocation.info}</p>
                <Button className="modalButton" onClick={showModal}>
                    {t('ShowLocation.FormList.LocationShareCode')}
                </Button>
                <Button className="modalButton" onClick={showModal1}>
                    {t('ShowLocation.FormList.ifLocationVisible')}
                </Button>
            </Flex>
            <Modal title={t('ShowLocation.ModalTitle')} open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                <p>{t('ShowLocation.FormList.LocationShareCode')}:...........</p>
            </Modal>
            <Modal title={t('ShowLocation.ModalTitle1')} open={isModalOpen1} onOk={handleOk1} onCancel={handleCancel1}
                footer={[
                    <Button key="submit" onClick={handleCancel1}>不隐藏</Button>,
                    <Button key="link" onClick={handleOk1}>隐藏</Button>
                ]}>
                <p>{t('ShowLocation.FormList.ifLocationVisible')}</p>
            </Modal>
        </Flex>
    )
}

export default MyShowLocationDetail